import React from 'react';

import Divider from '@mui/material/Divider';

import classes from 'components/common/bryntumScheduler/components/tooltips/EventTooltip.module.scss';
import { MilestoneTooltipData } from 'components/common/bryntumScheduler/components/tooltips/MilestoneTooltipData';
import { SummaryTooltipData } from 'components/common/bryntumScheduler/components/tooltips/SummaryTooltipData';
import {
    CombinedTooltipProps,
    MilestoneTooltipProps,
    SummaryTooltipProps,
} from 'components/common/bryntumScheduler/components/tooltips/types';

export const EventTooltip = ({ data }: CombinedTooltipProps) => {
    const eventRecord = data.eventRecord.originalData;
    return (
        <div className={classes.tooltipContainer}>
            <div className={classes.header}>{eventRecord.name}</div>
            <Divider />
            {eventRecord.isMilestone ? (
                <MilestoneTooltipData data={data as MilestoneTooltipProps['data']} />
            ) : (
                <SummaryTooltipData data={data as SummaryTooltipProps['data']} />
            )}
        </div>
    );
};
